import React from "react";

import "./TermsAndConditionsModal.scss";

const TermsAndConditionsModal = () => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="terms">
          <p className="terms-title">USLOVI PLAĆANJA</p>
          <p className="sub-title">
            <strong>PRODAVAC</strong>
          </p>
          <ul className="terms-list">
            <li>WE ARE FANCEE DOO</li>
            <li>Srebrnička 3</li>
            <li>11000 Beograd</li>
            <li>MB: 21940291</li>
            <li>PIB:113886255</li>
            <li>
              <a
                href="https://wearefancee.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://wearefancee.com
              </a>
            </li>
            <li>+381 69 16 4 1992</li>
            <li>
              <a
                href="mailto:partizan@wearefancee.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                partizan@wearefancee.com
              </a>
            </li>
            <li>
              <a
                href="mailto:tickets@kkpartizan.rs"
                target="_blank"
                rel="noopener noreferrer"
              >
                tickets@kkpartizan.rs
              </a>
            </li>
          </ul>
          <h2>USLOVI KORIŠĆENJA ONLINE USLUGE WE ARE FANCEE</h2>
          <p>
            Vaše korišćenje veb stranice fanceetickets.com, kao i usluge
            kupovine/prodaje karata na mreži fanceetickets.com (u daljem tekstu
            „Usluga“) podleže ovim Uslovima korišćenja. Ovi Uslovi korišćenja
            predstavljaju ugovor između We Are Fancee d.o.o. Beograd (u daljem
            tekstu „WAF“, „Naš“) i posetioca veb stranice fanceetickets.com
            i/ili kupca karata (u daljem tekstu „Vi“, Vaš). Ako ste organizacija
            koja prodaje karte ili upravlja blagajnama sa WE ARE FANCEE sistemom
            za upravljanje blagajnama, vaše korišćenje i rad na tom sistemu je
            regulisano Ugovorom o WE ARE FANCEE prodavcu i uslovima usluge.
          </p>

          <h2>USLUGA</h2>
          <p>
            Veb sajt fanceetickets.com i WE ARE FANCEE servis namenjeni su
            organizacijama koje žele da prodaju karate onlajn direktno
            posetiocima ili potencijalnim kupcima karata. Sajt fanceetickets.com
            kao domen direktno, nisu povezani ni sa jednom od organizacija koje
            prodaju karte preko Servisa.
          </p>

          <h2>KARTE</h2>
          <p>
            Dostupnost i cene karata. O dostupnosti broju ulaznica za događaje
            ili nastupe, odlučuje isključivo organizacija. Cene ulaznica
            određuje organizacija koja prodaje karte. Povrh cene karte (bilo
            kojih troškove usluge), WAF obračunava naknadu za obradu uplata koju
            zadržava WAF.
          </p>

          <h2>KUPOVINA KARATA</h2>
          <p>
            Ako kupite karte od prodavca preko Servisa, karta će vam biti
            poslata putem e-pošte nakon što je proces kupovine karte završen.
            Nećete dobiti papirnu kopiju karte od WAF, već samo elektronsku
            kopiju kupljene karte.
          </p>

          <h2>POVRAĆAJ SREDSTAVA</h2>
          <p>
            Povrat sredstava prethodno kupljenih ulaznica predstavlja
            diskreciono pravo organizacije koja prodaje (mi nemamo diskreciono
            pravo u vezi sa povraćajem novca) i može se obaviti samo preko te
            organizacije. U slučaju prevelikog plaćanja ili drugih grešaka
            uzrokovanih samim WAF servisom i kada se te greške potvrde, povraćaj
            sredstava može biti izvršen prema nahođenju WAF. U tom slučaju,
            kontaktirajte We Are Fancee podršku putem{" "}
            <a href="mailto:info@fanceetickets.com">info@fanceetickets.com</a>.
          </p>

          <h2>KONTAKTIRAJTE PRODAJNU ORGANIZACIJU</h2>
          <p>
            Ako imate bilo kakvih pitanja za prodavca ulaznica (organizatora
            događaja), možete ga kontaktirati putem kontakt podataka navedenih u
            potvrdi prijema vaše karte, koju vam WAF šalje elektronskim putem.
          </p>

          <h2>OTKAZIVANJE NARUDŽBI</h2>
          <p>
            Zadržavamo pravo da otkažemo bilo koju kupovinu karte iz bilo kog
            razloga, uključujući, ali ne ograničavajući se na nepotpune ili
            netačne informacije o plaćanju, kupovine neregularnim karticama ili
            bilo koje drugo kršenje WAF Politike prihvatljivog korišćenja,
            odredbi i uslova u ugovoru.
          </p>

          <h2>POLITIKA KORIŠĆENJA</h2>
          <p>
            Vaše korišćenje usluge podleže politici „prihvatljivog korišćenja“
            koju je uspostavila WAF. Glavni fokus ove politike je da ne
            koristite našu uslugu da biste počinili dela koja mogu biti štetna
            za WAF ili narušiti WAF-ine etičke standarde, vrednost i ugled.
            Zlonamerne radnje uključuju namernu zloupotrebu pristupa, datih
            privilegija ili licence, korišćenje dela zaštićenih autorskim
            pravima ili bilo kakvo kršenje intelektualne svojine, hakovanje,
            uključivanje trećih strana, DoS napade, namernu zloupotrebu ili
            lažno predstavljanje kupovine karata, menjanje ruta, vršenje
            robotski kontrolisanih kupovina ili pretvaranje ili predstavljanje
            kao veb-sajt WAF. S vremena na vreme, naš uvid u ono što je štetno
            može se promeniti kao rezultat novih (tehnoloških) razvoja.
            Standardi i vrednosti pri korišćenju našeg servisa odražavaju
            društvene norme i vrednosti. Postavljanje uvredljivih slika,
            tekstova, izjava ili klevetničkih izjava, ne predstavljaju
            prihvatljive društvene norme i moralne vrednosti, kao ni na primer
            izjave koje nemaju umetničku, književnu ili naučnu vrednost. Možemo,
            po sopstvenom nahođenju, privremeno blokirati vaš nalog ili potpuno
            blokirati pristup ako kršite ovu WAF politiku „prihvatljive
            upotrebe“.
          </p>

          <h2>POLITIKA PRIVATNOSTI</h2>
          <p>
            Vaše korišćenje usluge takođe podleže WAF politici privatnosti, koja
            se s vremena na vreme ažurira, kako bi bila u skladu sa aktuelnim
            propisima. Stranici Politika privatnosti se može pristupiti putem
            linka na početnoj stranici veb sajta WAF. Imajte na umu da se
            Politika privatnosti odnosi samo na Uslugu i ne obuhvata sajtove ili
            usluge trećih strana koje su putem Usluge povezane. Pored toga, sve
            informacije koje podelite sa prodavcem karata preko WAF ili van
            WAF-a, kao što su vaše ime i adresa e-pošte, podležu politici
            privatnosti tog prodavca.
          </p>

          <h2>IZJAVE, ODRICANJE OD ODGOVORNOSTI I OGRANIČENJE ODGOVORNOSTI</h2>
          <h2>IZJAVA</h2>
          <p>
            Usluga i veb stranica tibbaa.com nisu namenjeni deci mlađoj od 13
            godina. Korišćenjem Usluge, obećavate da ste stariji od 13 godina i
            da imate ovlašćenje ili odgovarajuću dozvolu za kupovinu karata
            kupljenih preko tibbaa.com.
          </p>

          <h2>ODRICANJE OD ODGOVORNOSTI</h2>
          <p>
            Usluga WAF se nudi „kao što jeste“ i mi ne dajemo nikakve garancije,
            izričite ili implicirane, uključujući, ali ne ograničavajući se na
            implicitne garancije za prodaju, prikladnost za određenu svrhu,
            nekršenje prava intelektualne svojine ili implicirane garancije koje
            proizilaze iz toga, pod bilo kojim važećim zakonom. Nismo u obavezi
            da vas obeštetimo ili branimo od tužbi u vezi sa povredom prava
            intelektualne svojine; i ne možemo garantovati da će Usluga raditi
            bez greške ili prekida.
          </p>

          <h2>OGRANIČENJE ODGOVORNOSTI</h2>
          <p>
            Ni u kom slučaju nećemo biti odgovorni za bilo kakvu štetu,
            uključujući posledičnu, indirektnu, posebnu, slučajnu ili kaznenu
            štetu koja proističe iz ili je u vezi sa vašim korišćenjem Usluge.
            Ograničenja odgovornosti u ovom odeljku se NE ODNOSI na odgovornost
            za nemar, bez obzira na oblik radnje i primenjiva su čak i ako smo
            unapred svesni mogućnosti štete i čak i ako je takva šteta bila
            predvidljiva. Ograničenja odgovornosti takođe važe čak i ako su vaši
            dostupni pravni lekovi neadekvatni. Ako važeći zakon ograničava
            primenu odredbi ovog odeljka, naša odgovornost će i dalje biti
            ograničena.
          </p>

          <h2>RAZLIČITI USLOVI</h2>

          <h2>IZMENE</h2>
          <p>
            Možemo s vremena na vreme da promenimo ove Uslove i odredbe
            objavljivanjem izmenjene verzije na našoj veb stranici. U bilo kom
            trenutku možemo da promenimo WAF politiku „prihvatljive upotrebe“
            ili našu politiku privatnosti. Preporučujemo vam da s vremena na
            vreme pregledate ove uslove.
          </p>

          <h2>PRENOS I ROK VAŽENJA</h2>
          <p>
            Nijedna strana ne može preneti ovaj Ugovor ili bilo koje od svojih
            prava ili obaveza u nastavku, bez izričite pismene saglasnosti
            druge, izuzev prenosa Ugovora na pravno lice koje bi, usled
            eventualnog spajanja naše kompanije sa drugom, predstavljalo novo
            nastalo pravno lice. Osim u onoj meri u kojoj prenos nije dozvoljen
            u prethodnoj rečenici, ovaj sporazum će biti obavezujući za (i
            koristi će sticati) pravne naslednike strana.
          </p>

          <h2>VAŽEĆE PRAVO - HOLANDIJA</h2>
          <p>
            Ovaj Ugovor je sastavljen u Holandiji i regulisan je holandskim
            zakonom. Naručilac se slaže sa isključivom jurisdikcijom sudova u
            Hagu, Holandiji.
          </p>

          <h2>AUTORSKA PRAVA</h2>
          <p>
            Ako verujete da je vaše delo zaštićeno autorskim pravima postavljeno
            na WAF veb lokaciju bez dozvole i da izuzeci za pošteno korišćenje
            nisu primenljivi ili su prekoračeni, možete poslati e-mail sa opisom
            netačne upotrebe na{" "}
            <a href="mailto:info@fanceetickets.com">info@fanceetickets.com</a>.
          </p>

          <h2>NEVAŽENJE</h2>
          <p>
            U meri u kojoj to dozvoljava važeći zakon, strane se odriču svih
            zakonskih odredbi koje bi dovele do toga da klauzula ovog sporazuma
            bude nevažeća ili na drugi način neprimenljiva u bilo kom pogledu. U
            slučaju da je neka odredba ovog sporazuma ipak nevažeća ili na neki
            drugi način neprimenljiva, tada će se ta odredba tumačiti na način
            da se što je bliže moguće približi cilju predviđenom tom odredbom (u
            najvećoj meri dozvoljenoj važećim zakonodavstvom), dok će ostale
            odredbe ovog Ugovora ostati na snazi.
          </p>

          <h2>DRUGI PRAVNI DOKUMENTI</h2>
          <p>
            Politika privatnosti (posetilac/kupac kartice) Ugovor o prodavcu WAF
            i uslovi usluge (organizatori događaja).
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsModal;
